import React from 'react';
import { ArrowRight } from 'lucide-react';

const PAU_IMAGE = '/images/pau.jpg';
const FALLBACK_IMAGE = 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop';
const LINKEDIN_URL = 'https://www.linkedin.com/in/pauasensio/';
const LINKTREE_URL = 'https://linktr.ee/PauAsensio';

const AboutSection = ({ t }) => (
  <section id="sobre-mi" className="py-12 bg-gray-50 curtain-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div className="scroll-reveal-left flex justify-center">
          <div className="relative w-80 h-80 overflow-hidden rounded-2xl shadow-2xl hover-lift">
            <img
              src={PAU_IMAGE}
              alt="Pau Asensio"
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.src = FALLBACK_IMAGE;
              }}
              data-testid="about-pau-image"
            />
          </div>
        </div>
        <div className="scroll-reveal-right">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            {t.about.title} <span className="text-gradient">{t.about.titleHighlight}</span>
            {t.about.titleEnd}
          </h2>
          <p className="text-lg text-gray-700 mb-6 leading-relaxed whitespace-pre-line">{t.about.description1}</p>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed whitespace-pre-line">{t.about.description2}</p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href={LINKEDIN_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-700 transition-all transform hover:scale-105 inline-flex items-center justify-center gap-2 magnetic-effect"
              data-testid="about-linkedin-cta"
            >
              <ArrowRight className="w-5 h-5" />
              {t.about.cta}
            </a>
            <a
              href={LINKTREE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-blue-600 text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-600 hover:text-white transition-all transform hover:scale-105 inline-flex items-center justify-center gap-2 magnetic-effect"
              data-testid="about-linktree-cta"
            >
              {t.about.ctaLinktree}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AboutSection;
